import { useEffect } from 'react';
import { useLocation } from 'react-router';

const PaymnetPage = () => {
  const location = useLocation();
  const parsedQuery = new URLSearchParams(location.search);

  useEffect(() => {
    window.gtag('event', 'purchase', {
      transaction_id: parsedQuery.get('billID'),
      affiliation: parsedQuery.get('platform'),
      value: parsedQuery.get('price'),
      currency: 'USD',
      tax: 0,
      shipping: 0,
      items: [
        {
          id: parsedQuery.get('cardID'),
          name: parsedQuery.get('service'),
          price: parsedQuery.get('price'),
        },
      ],
    });
    document.getElementById('midPaymentForm').submit();
  }, []);

  return (
    <form
      id="midPaymentForm"
      style={{ display: 'none' }}
      action={parsedQuery.get('url')}
      method="post"
    >
      <input name="RedirectURL" value={parsedQuery.get('redirectUrl')} />
      <input name="Token" value={parsedQuery.get('token')} />
    </form>
  );
};

export default PaymnetPage;
